module.exports = __webpack_public_path__ + "static/media/MAAS-Customer-Service-Chatbot.9958982c.png";